const USER_ROLE_LABELS: Record<string, string> = {
  admin: "Administrador",
  project_manager: "Jefe de Proyecto",
  technician: "Técnico",
  admin_manager: "Jefe de Administración",
  sales: "Comercial",
  sales_admin: "Administrador comercial",
};

export function getUserRoleLabel(role: string): string {
  return USER_ROLE_LABELS[role] ?? role;
}
